import { postHogService } from '../application/PostHogService';

export const useCaptureEvents = () => {
  return { capture: postHogService.capture };
};
